import React from 'react';
import useTranslations from '../../hooks/useTranslations';
import FormBuilderShareAccessSettingsDialogEngine from '../engine/FormBuilderShareAccessSettingsDialogEngine';
import Link from '../Link';
import styled from 'styled-components';
import { SimpleFlexContainer } from '../layouts/ng-layouts/Containers';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import Colors from '../../internal-components/Colors';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import MuiEditIcon from '@material-ui/icons/Edit';

const SubText = styled.small``;

const AccessSettingSpan = styled.span`
  align-items: center;
  display: flex;
  margin: 0.8rem 0;

  svg {
    height: 20px;
    width: 20px;
    margin-right: 0.4rem;
    color: ${({ $colored }) => ($colored ? Colors.PRIMARY : Colors.OT_GREY)};
  }

  button {
    margin-left: 0.2rem;
  }
`;

const LimitAccessGroupsContainer = styled.div`
  display: flex;
  align-items: center;
`;

const EditIcon = styled(MuiEditIcon)`
  && {
    width: 1rem;
    height: 1rem;
  }
`;

const EditLimitAccessGroupBtn = styled(IconButton)`
  && {
    margin-right: 0.4rem;
  }
`;

const GroupContainer = styled(SimpleFlexContainer)`
  flex-wrap: wrap;
  gap: 0.4rem;
  padding: 0 0.4rem;
`;

const FormBuilderAccessSettingView = props => {
  const t = useTranslations();
  return (
    <>
      <SimpleFlexContainer>
        <AccessSettingSpan>
          {props.isPublic ? <LockOpenIcon /> : <LockIcon />}
          <SubText>
            {`${t(
              `form-builder.share.access.${
                props.isPublic ? 'public' : 'internal'
              }`
            )} • `}
          </SubText>
          <Link onClick={() => props.setIsAccessSettingDialogOpen(true)}>
            <SubText>{t('form-builder.share.access.link')}</SubText>
          </Link>
        </AccessSettingSpan>
        {!!(props.limitAccessGroups2Display || []).length && (
          <LimitAccessGroupsContainer>
            <SubText>
              {t('form-builder.share.access.limit-access-groups.sub-title')}
            </SubText>
            <GroupContainer $row>
              {props.limitAccessGroups2Display.map(group => (
                <Chip
                  key={group.value}
                  label={group.label}
                  variant="outlined"
                  size="small"
                />
              ))}
            </GroupContainer>
          </LimitAccessGroupsContainer>
        )}
      </SimpleFlexContainer>
      <FormBuilderShareAccessSettingsDialogEngine
        isOpen={props.isAccessSettingDialogOpen}
        setIsOpen={props.setIsAccessSettingDialogOpen}
        reducerListener={props.onDialogStateChanged}
      />
    </>
  );
};

export default FormBuilderAccessSettingView;
